/*
export type State = ?string;
*/

const defaultState = null;

export default (state = defaultState) => state;
